module.exports = __webpack_public_path__ + "static/media/day13.7aef5468.jpg";